module.exports = __webpack_public_path__ + "img/rond-jaune.b1317b4d.png";